import { AttributeCollection, getNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { SiteData } from "../Data/SiteData";
import { MapInputsFromEditList, UpdateStyleFunction } from "../Stylebuilder";
import { useRef, useState } from "react";
import { AttributeGroups, attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import GetAttributeDefinition, { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";


export default function RenderInputsWithTabs({editList,layoutNode,screenSize,updateFunc,saveFunc,siteData,colorList}:{colorList:string[],editList:string[],layoutNode:AttributeCollection|null,screenSize:ScreenSize,updateFunc:UpdateStyleFunction,saveFunc:Function,siteData:SiteData}){


    const isModdedRef = useRef(false);
    
    const [currentTab,setCurrentTab] = useState(0);
    const groups = [
        {
            name:"Colors",
            icon:<ColorsIcon/>,
            attributes:colorList??[]
        }
        ,...AttributeGroups];

    let currentGroup = groups[currentTab]??{name:"",attributes:[]};
    let list = currentGroup.attributes.filter((att)=>{return editList.includes(att)});
    const [toggle,setToggle] = useState(false);

    const updateWrapper = (att:string,val:string,target:any)=>{

        if(layoutNode){
            if(att==attributeTypes.backgroundColor||att==attributeTypes.color){
        
                let g = getNodeStyleAttributeValue(layoutNode,screenSize,att);
                //force update colors since they can exist in multiple groups
                if(((g == "" && val!="")||(g!="" &&val=="" ))){
                    updateFunc(att,val,target);
                    setToggle(!toggle);
                    return;
                }
            }
            else if((val==""&&isModdedRef.current)||(val!=""&&!isModdedRef.current)){
                updateFunc(att,val,target);
                isModdedRef.current = val!="";
                setToggle(!toggle);
                return;
    
            }
          
            updateFunc(att,val,target);
        }

    }

    const saveWrapper = ()=>{
   
        saveFunc();
    }

    return (
        <div className="w-full"> 
        <style>
            {`
            
            .input-tab{
                position:relative;
                padding:0.8rem; 
                border-radius:6px 6px 0px 0px;
            }

            .input-tab.modded::after{
                    content: " ";
                    background: var(--input-selected-primary);
                    border-radius: 100px;
                    width: 6px;
                    height: 6px;
                    position: absolute;
                    left: 6px;
                    top: 8px;
            }

            .input-tab-row{
                margin:0 -8px;
            }
            .input-tab:hover{
               background:#00000005 !important;
               }
            .input-tab.selected{
               background:#00000010 !important;
               }
            .input-tab-content{
                background:#00000010;
                margin:0 -8px;
                padding:12px;
                border-radius:4px;
                }
            .input-tab-content .wb-input-group:last-child{
               border-bottom:none !important;
            }

            `

            /*
      .input-tab-content .wb-input-group:last-child{
                padding-bottom:4px !important;
            }
            */
            }
        </style>

        <div className="input-tab-row flex-row">
            {groups.map((group,index)=>{
            
                let testList = (group.attributes)? group.attributes.filter((att)=>{return editList.includes(att)}):[];
               
                

                if(testList.length<=0){
                    
                    if(currentTab<groups.length && index == currentTab){
                        setCurrentTab(index+1);
                    }
                    return null;


                }
                if(group.name == "BG"){ // special case to handle check for bg color since bg group only has image value to avoid rendering color twice
                    testList.push(attributeTypes.backgroundColor);
                    testList.push("dropdownBg") // add special case for navigation background color.
                }
            

                let isModded = false;
                if(layoutNode){
                    for(let i = 0;i<testList.length;i++){
                        let val = GetComponentOrStyleValueFromDefinition(GetAttributeDefinition(testList[i]),layoutNode,screenSize);
                        if(val){
                            isModded = true;
                            break;
                        } 
                    }

                }

                if(index == currentTab)
                isModdedRef.current = isModded;
           
                return (
                    <button key={index} style={{maxWidth:"50%"}} className={(isModded?"modded":"") +" input-tab w-full invisible-button flex-column gap-med align-center justify-center "+(currentTab===index?"selected":"")} onClick={()=>setCurrentTab(index)}>{group.icon}<span style={{fontSize:"11px"}}>{group.name.replace("Background","BG")}</span></button>
                )
            })}

        </div>
        <div className="input-tab-content" style={{paddingBottom:"0px",borderRadius:(currentTab==0)?"0px 6px 6px 6px":(currentTab==groups.length-1?"6px 0px 6px 6px":"6px")}}
        
        >
        <MapInputsFromEditList key={currentGroup.name}  updateFunc={updateWrapper} saveFunc={saveWrapper} editList={list} layoutNode={layoutNode} screenSize={screenSize} showScreenSize={true} siteData={siteData} sort={false}/>
        </div>
     <div style={{height:"500px"}}></div>
        </div>

    )


}

export function ColorsIcon(){


    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height={"1em"} fill="currentColor"><path d="M464 258.2c0 2.7-1 5.2-4.2 8c-3.8 3.1-10.1 5.8-17.8 5.8H344c-53 0-96 43-96 96c0 6.8 .7 13.4 2.1 19.8c3.3 15.7 10.2 31.1 14.4 40.6l0 0c.7 1.6 1.4 3 1.9 4.3c5 11.5 5.6 15.4 5.6 17.1c0 5.3-1.9 9.5-3.8 11.8c-.9 1.1-1.6 1.6-2 1.8c-.3 .2-.8 .3-1.6 .4c-2.9 .1-5.7 .2-8.6 .2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 .7 0 1.4 0 2.2zm48 .5c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48h97.9c36.5 0 69.7-24.8 70.1-61.3zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>
}